import React from 'react';

import { Box, Text, VStack, HStack, Divider } from '@chakra-ui/react';

import { useColors } from './colors';

/**
 * Consistent section wrapper for integration settings blocks.
 */
const IntegrationSection = ({
  title,
  description,
  rightElement,
  children,
  showDivider = true,
  noPadding = false,
}) => {
  const { textColor, borderColor, sectionBgColor } = useColors();

  return (
    <Box as="section" width="100%">
      {showDivider && <Divider borderColor={borderColor} mb={8} />}
      <VStack align="stretch" spacing={5}>
        {(title || rightElement) && (
          <HStack justify="space-between" align="flex-start" flexWrap="wrap" gap={3}>
            <Box flex="1" minW="200px">
              {title && (
                <Text fontSize="lg" fontWeight="semibold" color={textColor} lineHeight="short">
                  {title}
                </Text>
              )}
              {description && (
                <Text fontSize="sm" color="gray.500" mt={title ? 1 : 0} maxW="3xl">
                  {description}
                </Text>
              )}
            </Box>
            {rightElement}
          </HStack>
        )}
        <Box
          bg={noPadding ? 'transparent' : sectionBgColor}
          borderWidth={noPadding ? 0 : '1px'}
          borderColor={borderColor}
          borderRadius="xl"
          p={noPadding ? 0 : { base: 4, md: 6 }}
        >
          {children}
        </Box>
      </VStack>
    </Box>
  );
};

export default IntegrationSection;
